// echartsOption基本数据
export const option = {
  xAxis: {
    data: [], //横坐标
    axisLine: {
      show: false
    },
    axisTick: {
      show: false,

    },
    axisLabel: {//**该项配置重点关注**
      show: true,
      interval: 0,
      // width: xLabelWidth - 10,
      overflow: "breakAll"
    }
    // boundaryGap: false,
  },
  yAxis: [
    {
      type: 'value',
      x: 0,
      min: 0,
      axisLine: { lineStyle: { color: "#999" }, show: false },
      show: true
    },
  ],

  color: [], //颜色
  tooltip: {
    trigger: 'item',
    backgroundColor: '#fff',
    textStyle: {
      color: '#333',
      fontSize: '12',
      lineHeight: '25',
      fontWeight: 'bold'
    },
    axisPointer: {
      type: 'cross',
      crossStyle: {
        color: '#333'
      }
    }
  },
  grid: {
    left: '0%',
    right: '0%',
    bottom: '3%',
    containLabel: true,
    // show: 'true',
    borderWidth: '0'

  },
  // 图例
  legend: {
    data: [],
    top: "0%",
    left: '0%',
    icon: 'circle',

  },

  series: [

  ]
}
export const pieOption = {
  title: {
    left: 'center'
  },
  tooltip: {
    trigger: 'item',

  },
  legend: {

  },
  color: ['#FF7364', '#51ACD6',],
  series: []
}
export const lineOption = {

  tooltip: {
    trigger: 'axis'
  },
  legend: {
    top: "0%",
    left: '0%',
    icon: 'circle',
    data: []
  },
  grid: {
    left: '0%',
    right: '0%',
    bottom: '3%',
    containLabel: true,
    // show: 'true',
    borderWidth: '0'
  },
  toolbox: {
    feature: {
      saveAsImage: {}
    }
  },
  xAxis: {
    data: [], //横坐标
    axisLine: {
      show: false
    },
    axisTick: {
      show: false,

    },
    axisLabel: {//**该项配置重点关注**
      show: true,
      interval: 0,
      // width: xLabelWidth - 10,
      overflow: "breakAll"
    }
    // boundaryGap: false,
  },
  yAxis: [
    {
      type: 'value',
      x: 0,
      min: 0,
      axisLine: { lineStyle: { color: "#999" }, show: false },
      show: true
    },
  ],

  series: [

  ]
};